export default "__VITE_PUBLIC_ASSET__45bb5a0b__"